/* eslint-disable func-names */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-expressions */
import { isBrowser } from './responsiveWidthGetter';

const requestAnimFrame = () =>
  window.requestAnimationFrame ||
  window.webkitRequestAnimationFrame ||
  function(callback: Function) {
    return window.setTimeout(callback, 1000 / 60);
  };

export const requestTimeout = function(fn: Function, delay: number) {
  if (!isBrowser()) {
    return { value: 0 };
  }

  if (!window.requestAnimationFrame && !window.webkitRequestAnimationFrame) {
    return { value: window.setTimeout(fn, delay) };
  }

  const start = new Date().getTime();
  const handle: { value: number } = { value: 0 };

  const loop = () => {
    const current = new Date().getTime();
    const delta = current - start;

    delta >= delay ? fn() : (handle.value = requestAnimFrame()(loop));
  };

  handle.value = requestAnimFrame()(loop);
  return handle;
};

export const clearRequestTimeout = function(handle: number) {
  window.cancelAnimationFrame
    ? window.cancelAnimationFrame(handle)
    : window.webkitCancelAnimationFrame
    ? window.webkitCancelAnimationFrame(handle)
    : clearTimeout(handle);
};
